import Locale from "models/Locale";
import SurveyLocale from "models/SurveyLocale";

export const SET = "answerStart/SET";
export const CHANGE_LOCALE = "answerStart/CHANGE_LOCALE";
export const SET_TEMPORARY_SAVED = "answerStart/SET_TEMPORARY_SAVED";
export const CLEAR_TEMPORARY_SAVED = "answerStart/CLEAR_TEMPORARY_SAVED";
export const SET_TEMP_SAVED_ATTR_RESULT = "answerStart/SET_TEMP_SAVED_ATTR_RESULT";
export const SET_TEMP_SAVED_BASIC_RESULT = "answerStart/SET_TEMP_SAVED_BASIC_RESULT";
export const SET_RESPONDENT = "answerStart/SET_RESPONDENT";

export const set = (surveyLocales, localeId) => ({
  type: SET,
  surveyLocales: surveyLocales.map(sl => {
    return new SurveyLocale(sl).set("locale", new Locale(sl.locale));
  }),
  localeId
});

export const changeLocale = localeId => ({
  type: CHANGE_LOCALE,
  localeId
});

export const setTemporarySaved = (tempSavedState, tempSavedPath) => ({
  type: SET_TEMPORARY_SAVED,
  tempSavedState,
  tempSavedPath
});

export const clearTemporarySaved = () => ({
  type: CLEAR_TEMPORARY_SAVED
});

export const setTempSavedAttrResult = tempSavedAttrResult => ({
  type: SET_TEMP_SAVED_ATTR_RESULT,
  tempSavedAttrResult
});

export const setTempSavedBasicResult = tempSavedBasicResult => ({
  type: SET_TEMP_SAVED_BASIC_RESULT,
  tempSavedBasicResult
});

export const setRespondent = (isRespondent) => ({
  type: SET_RESPONDENT,
  isRespondent
});

const initialState = {
  surveyLocale: new SurveyLocale(),
  surveyLocales: [],
  isTemporarySaved: false,
  tempSavedPath: null,
  tempSavedAttrResult: {},
  tempSavedBasicResult: {},
  isRespondent: false
};

const answerStart = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET: {
      const { surveyLocales } = action;
      const localeId = action.localeId
        ? action.localeId
        : surveyLocales[0].locale.id;
      const surveyLocale = surveyLocales.find(sl => sl.locale.id === localeId);

      return { ...state, surveyLocale, surveyLocales };
    }
    case CHANGE_LOCALE: {
      const surveyLocale = state.surveyLocales.find(
        sl => sl.locale.id === action.localeId
      );
      return { ...state, surveyLocale };
    }
    case SET_TEMPORARY_SAVED: {
      return {
        ...state,
        isTemporarySaved: true,
        tempSavedPath: action.tempSavedPath
      };
    }
    case CLEAR_TEMPORARY_SAVED: {
      return {
        ...state,
        isTemporarySaved: false,
        tempSavedPath: null,
        tempSavedAttrResult: {},
        tempSavedBasicResult: {}
      };
    }
    case SET_TEMP_SAVED_ATTR_RESULT: {
      return {
        ...state,
        tempSavedAttrResult: action.tempSavedAttrResult
      };
    }
    case SET_TEMP_SAVED_BASIC_RESULT: {
      return {
        ...state,
        tempSavedBasicResult: action.tempSavedBasicResult
      };
    }
    case SET_RESPONDENT: {
      return { 
        ...state, 
        isRespondent: action.isRespondent 
      };
    }
    default:
      return state;
  }
};

export default answerStart;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerStart.js